import React, { useState } from 'react'
import { FormattedDate, FormattedTime } from 'react-intl'
import Icon from 'components/Icon'

const Feedback = ({ last, timestamp, body, meta, title }) => {
  const { link } = meta

  const [hoveredRating, setHoveredRating] = useState(null)

  return (
    <li>
      <div className="relative pb-8">
        { !last &&
          <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
        }
        <div className="relative flex items-start space-x-3">
          <div>
            <div className="relative px-2 mt-2">
              <div className="h-6 w-6 bg-yellow-400 rounded-full ring-4 ring-white flex justify-center items-center">
                <Icon icon="star" className="text-xs text-white" />
              </div>
            </div>
          </div>

          <div className="min-w-0 flex-1 py-0">
            <div className="text-sm leading-6">
              <div className="border border-gray-200 rounded-sm mb-2">

                <div className="border-t border-gray-200 px-2 space-x-1 flex justify-between items-center">
                  <span className="text-gray-400">
                    {title}
                  </span>
                  {link &&
                    <div className="flex space-x-1 items-center">
                      {[...Array(5)].map((_, i) => {
                        const starValue = i + 1;
                        const isHighlighted = (hoveredRating >= starValue)

                        return (
                          <button
                            key={i}
                            className={`text-2xl transition-colors ${
                              isHighlighted ? "text-yellow-500" : "text-gray-400"
                            } hover:text-yellow-500`}
                            onMouseEnter={() => {
                              setHoveredRating(starValue);
                            }}
                            onMouseLeave={() => {
                              setHoveredRating(null);
                            }}
                            onClick={() => {
                              window.open(`${link}&rating=${starValue}`);
                            }}
                          >
                            &#9733;
                          </button>
                        );
                      })}
                    </div>
                  }
                </div>
              </div>

              <span className="whitespace-nowrap text-gray-500 text-xs">
                <FormattedDate value={timestamp * 1000} /> <FormattedTime value={timestamp * 1000} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default Feedback
